module.exports = "<p>\r\n  permisos works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/permisos/permisos.component.html
// module id = ../../../../../src/app/components/permisos/permisos.component.html
// module chunks = main